module.exports = __webpack_public_path__ + "img/Villa_Borna_68.e2a7413c.jpg";